import React from 'react';
import { Component } from 'ml-component-web';
import RetinaImage from 'react-retina-image';
import Modal from '../shared/modal/Modal';
import Analytics from '../shared/google-analytics/Analytics';

import './home.css';
import './success.css';
import './invitation.css';
import logo from '../assets/logo_100.png';
import logo2x from '../assets/logo_100@2x.png';
import apple from '../assets/apple_app_store.svg';
import apple2x from '../assets/apple_app_store@2x.svg';
import google from '../assets/google_app_store.png';
import google2x from '../assets/google_app_store@2x.png';


export default class InvitationHandlerView extends Component {

    downloadAndroid = () => {
        Analytics.sendEvent({
            ga: {
                category: 'Download',
                action: 'Android',
            },
        });
    }

    downloadApple = () => {
        Analytics.sendEvent({
            ga: {
                category: 'Download',
                action: 'Apple',
            },
        });
    }

    renderComponent() {
        const {
            invitation,
        } = this.props;

        let invitedByElement;
        if (invitation && invitation.invitedBy && invitation.children) {
            const childInvitation = invitation.children[Object.keys(invitation.children)[0]];
            invitedByElement = (
                <span className="success-text">
                    {invitation.invitedBy.nickname ? invitation.invitedBy.nickname : invitation.invitedBy.name} has invited you to see {childInvitation.nickname ? childInvitation.nickname : childInvitation.name} on MyBabyBio<br />
                </span>
            );
        } else if (invitation && invitation.invitedBy) {
            invitedByElement = (
                <span className="success-text">
                    {invitation.invitedBy.nickname ? invitation.invitedBy.nickname : invitation.invitedBy.name} has invited you to have early access to MyBabyBio<br />
                </span>
            );
        } else if (invitation) {
            invitedByElement = (
                <span className="success-text">
                   You've been invited to have early access to MyBabyBio<br />
                </span>
            );
        }
        return (
            <div className="early-access-container home-jumbotron">
                <div className="home-jumbotron-cover orange" data-color="orange" />
                <div className="subscribe early-access">
                    <Modal name="success" className="success-modal">
                        <div className="home-jumbotron-header my-modal-header">
                            <RetinaImage className="logo" src={[logo, logo2x]} alt="MyBabyBio" />
                            <h1 className="logo-text">MyBabyBio</h1>
                        </div>
                        <div className="my-modal-body">
                            <p className="success-position">
                                <h2 className="early-access-text">Early Access</h2>
                                {invitedByElement}
                            </p>
                            <div className="download">
                                <p>Download now on your Apple or Android device:</p>
                                <a href={invitation && invitation.invitationUrl.indexOf('mybabybio.com') === -1 ? invitation.invitationUrl : 'https://itunes.apple.com/gb/app/mybabybio-online-baby-diary/id1171889819?ls=1&mt=8'} className="cta2 download" onClick={this.downloadApple}>
                                    <RetinaImage alt="Download on the App Store" src={[apple, apple2x]} />
                                </a>
                                <a href={invitation && invitation.invitationUrl.indexOf('mybabybio.com') === -1 ? invitation.invitationUrl : 'https://play.google.com/store/apps/details?id=com.mybabybio'} className="cta2 download" onClick={this.downloadAndroid}>
                                    <RetinaImage alt="Get it on Google Play" src={[google, google2x]} />
                                </a>
                                {invitation && invitation.invitationUrl.indexOf('mybabybio.com') !== -1 && (
                                    <p>Once you've installed MyBabyBio, just click the invitation again to accept the invitation in the app</p>
                                )}
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/handler/InvitationHandlerView.js
 **/